import { Box, Tooltip } from '@mui/material';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

type BetaFlagProps = {
  text?: string;
  fontSize?: SvgIconProps['fontSize'];
  color?: SvgIconProps['color'];
  disabled?: boolean;
};

export const BetaFlag = memo(
  ({
    text = 'Beta',
    fontSize = 'small',
    color = 'info',
    disabled = false,
  }: BetaFlagProps) => {
    const { t } = useTranslation();
    const title = disabled ? t('blox.navigation.beta_requires_program') : text;
    return (
      <Tooltip
        title={title}
        disableInteractive
        className="betaflag-wrapper"
      >
        <Box
          data-testid="beta-flag-icon"
          component="span"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          <ScienceOutlinedIcon
            color={color}
            fontSize={fontSize}
          />
        </Box>
      </Tooltip>
    );
  },
);
BetaFlag.displayName = 'BetaFlag';
